
import { Helmet } from "react-helmet";
import { safeJsonStringify } from "@/lib/utils";

interface FAQItemProps {
  question: string;
  answer: string;
}

interface FAQSchemaProps {
  items: FAQItemProps[];
  mainEntity?: string;
  context?: string;
}

export const FAQSchema = ({ items, mainEntity, context }: FAQSchemaProps) => {
  // Create a schema for FAQ entries
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": items.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };
  
  // If provided, add a main entity context
  if (mainEntity) {
    faqSchema["about"] = {
      "@type": "Thing",
      "name": mainEntity,
      "description": context || `Frequently asked questions about ${mainEntity}`
    };
  }
  
  return (
    <Helmet>
      <script type="application/ld+json">
        {safeJsonStringify(faqSchema)}
      </script>
    </Helmet>
  );
};
